import React from 'react';

import LabelAndDate from '../../../LabelAndDate';

export const prop = 'activityDate';

const ActivityDateColumn = ({activityDate}) => {
	const props = {date: activityDate, withHours: false, body1: true};
	return <LabelAndDate {...props} />;
};

export const config = (labels) => ({
	id: 'activityDateColumn',
	label: labels.activityDate,
	propName: prop,
	width: 'minmax(14rem, 2fr)',
	sortBy: prop,
	customCell: (item) => <ActivityDateColumn {...item} />
});
